import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class CrosstabSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    const translationPrefix = `widgets.ai-insights.summary.${widget.payload.type}.${widget.payload.display.showAsPercentage ? 'percentage' : 'count'}`;

    return selectedPoints.map((p, idx) => {
      const translationKey = `${translationPrefix}.${idx === 0 ? 'first-point' : 'rest-of-points'}`;

      let count = p.documentCount;
      if (widget.payload.display.showAsPercentage) {
        count *= 100;
      }

      return {
        translationKey,
        translationParams: {
          row: p.y,
          column: p.x,
          count: Utils.round(count),
        },
      };
    });
  }
}
